export const emailRequestTypeOptions = [
  { label: 'order_help', value: 'Order Help' },
  { label: 'general_help', value: 'General Help' },
  { label: 'part_identification', value: 'Part Identification' },
  { label: 'report_bug', value: 'Report Bug' }
];
